"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

const FooterList = dynamic(async () => (await import("./FooterList")).FooterList);

export const listInputs = [
  {
    name: "items",
    type: "list",
    required: true,
    copyOnAdd: false,
    subFields: [
      {
        name: "title",
        type: "string",
        required: true,
      },
      {
        name: "link",
        type: "url",
        required: true,
      },
      {
        name: "isArrowHidden",
        type: "boolean",
        defaultValue: false,
        helperText: "Hide arrow",
      },
      {
        name: "trackingEvent",
        type: "string",
        defaultValue: "",
        enum: ["phone_click", "contact_click", "store_locator_click"],
      },
    ],
    defaultValue: [
      {
        title: "Special Deals",
        link: "/",
      },
      {
        title: "Special Offers",
        link: "/",
      },
      {
        title: "Special Discounts",
        link: "/",
      },
    ],
  },
] as const satisfies Inputs;

export const FooterListComponent: RegisteredComponent = {
  name: "FooterList",
  component: FooterList,
  defaultStyles: {
    marginTop: "0px",
  },
  inputs: listInputs,
};
